import axios from 'axios';

export const api = axios.create({
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- `||` also falls back when the variable is set but empty; `??` would not
  baseURL: `${import.meta.env.VITE_API_BASE_URL || ''}/v1`,
  withCredentials: true,
  timeout: Number(import.meta.env.VITE_API_TIMEOUT_MS ?? 10000),
});
